export default "__VITE_ASSET__bwOVJW4___"